import { render } from "./InputTimeFrameAmount.vue?vue&type=template&id=2964ab3c"
import script from "./InputTimeFrameAmount.vue?vue&type=script&lang=js"
export * from "./InputTimeFrameAmount.vue?vue&type=script&lang=js"
script.render = render

export default script